import { gatewayEcomServices } from '../../../../configurations/configuration.json';

class ClButtonsApiHandler {

    #API_URL

    constructor() {
        this.#API_URL = gatewayEcomServices;
    }

    async getButton(reqBody) {
        const endpoint = '/reqAmount';
        // const { price, desc, btnName } = reqBody;
        return fetch(`${this.#API_URL}${endpoint}`, {
            body: JSON.stringify([{ maxAmount: 15000, ...reqBody }]),
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            mode: 'cors'
        })
            .then(res => res.json())
            .catch(err => {
                console.log(err);
                return '';
            });
    }

    async getAllThemes() {
        const endpoint = '/themes';
    }

    async getAllLightModes() {
        const endpoint = '/lightModes';
    }

    async getBtnGroups(btnGrpArr = ['ALL']) {
        const params = btnGrpArr.map(btnGrpName => 'btnGrp=' + btnGrpName).join('&');
        const endpoint = `/plg/wp-btn/button?${params}`;
        return fetch(`${this.#API_URL}${endpoint}`, {
            headers: new Headers({ 'Content-Type': 'application/json' })
        }).then(res => res.json())
            .catch(err => {
                console.log(err)
                return [];
            });
    }

    async getButtonOption(btnName) {
        const endpoint = '/buttons';
        let btnOptionResult;
        const btnsRes = await fetch(`${this.#API_URL}${endpoint}?name=${btnName}`).then(res => res.json());
        if (btnsRes?.code === '200' || btnsRes?.code === '201') {
            btnOptionResult = btnsRes.object;
        } else {
            btnsRes?.errors && console.log('%ccls_ecomm_services_errors:\n' + btnsRes.errors, 'background: red;');
        }
        return btnOptionResult
    }

    async getAllButtonOptions(quertParams = {}) {
        const endpoint = '/buttons';
        const params = Object.entries(quertParams).map(([pName, pVal]) => `${pName}=${pVal}`).join('&');
        const btnOptsRes = await fetch(`${this.#API_URL}${endpoint}?${params}`, {
            method: 'GET'
        });
        const resParsed = await btnOptsRes.json();
        let btnOpts = [];
        // console.log(`${this.#API_URL}${endpoint}?${params}`);
        if (btnOptsRes?.status === 200 || btnOptsRes?.status === 201) {
            btnOpts = resParsed.object;
        }
        if (String(btnOptsRes.status).startsWith('4') || String(btnOptsRes.status).startsWith('5')) {
            console.log('%ccls_ecomm_services_errors:\n', 'background: red');
            resParsed?.errors && console.log('%cerrors:\n' + resParsed.errors, 'background: red');
            console.log(btnOptsRes, '\n', resParsed);
        }
        return btnOpts;
    }
}

export default ClButtonsApiHandler;